module.exports = __webpack_public_path__ + "img/Priest-nightelf-f-70.235226ca.gif";